import { z } from 'zod';
import { Api } from '@automapa/svelte-automapa-template';
import { disableRefreshing } from '../../../stores/store';
import { get } from 'svelte/store';

export const StatusResponseSchema = z.object({
    status: z.number(),
    version: z.string(),
    date: z.string(),
    ts: z.number(),
    instance_id: z.string().catch('???'),
});
export type StatusResponseType = z.infer<typeof StatusResponseSchema>;

export class StatusApi {
    public static async check(api: Api) {
        if (get(disableRefreshing)) {
            console.warn('StatusApi, check, disableRefreshing');
            return new Promise((resolve, reject) =>
                resolve({
                    status: 1,
                    version: '1.0.0',
                    date: '2024-06-09 11:10:00',
                    ts: 1717924200,
                })
            );
        }
        return api.getData<any, StatusResponseType>(
            'post',
            `/status/check`,
            {},
            z.object({}),
            StatusResponseSchema
        );
    }
}
